export const styles = theme => ({
  searchTextField: {
    display: 'flex',
    flex: 1,
    maxWidth: 488,
    color: theme.palette.text.primary,
    background: theme.palette.background.primary,
    borderRadius: 8,
    maxHeight: 42,
    flexShrink: 0,
  },
  multiSearchTextField: {
    display: 'flex',
    maxWidth: 488,
    color: theme.palette.text.primary,
    background: theme.palette.background.primary,
    borderRadius: 8,
    flexShrink: 0,
    '& .MuiInputBase-root': {
      flexWrap: 'wrap',
    },
    '& .search-text-field-multi-items-wrapper': {
      display: 'flex',
      flex: 1,
      flexWrap: 'wrap',
      alignItems: 'center',
      marginTop: theme.spacing(2),
      gap: theme.spacing(1),
    },
  },
  searchIcon: {
    color: theme.palette.text.primary,
  },
  clearIcon: {
    cursor: 'pointer',
    color: theme.palette.text.primary,
    '&:hover': {
      color: theme.palette.text.dark,
    },
  },
  adornedStart: {
    paddingLeft: 10,
  },
  adornedEnd: {
    paddingRight: 12,
  },
  cssInput: {
    backgroundColor: theme.palette.background.primary,
    border: 0,
    borderRadius: 8,
    '&:not(hover):not($cssFocused) $notchedOutline': {
      border: 0,
    },
    '&:hover:not($cssFocused) $notchedOutline': {
      border: 0,
      borderRadius: 8,
    },
    '&$cssFocused $notchedOutline': {
      border: `1px solid ${theme.palette.text.primary}`,
      borderRadius: 8,
    },
    '& input': {
      paddingTop: 8,
      paddingBottom: 10,
    },
  },
  notchedOutline: {},
  cssFocused: {},
});

export default styles;
